/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
// Core
import { ControlComponent } from '../../core/component/control.component';
// JQX Widget
import { jqxNotificationComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxnotification';

/**
 * Notification
 */
@Component({
    selector: 'ngc-notification',
    template: `<jqxNotification #jqxNotification
                [appendContainer] = "appendContainer"
                [autoOpen] = "autoOpen"
                [animationOpenDelay] = "animationOpenDelay"
                [animationCloseDelay] = "animationCloseDelay"
                [autoClose] = "autoClose"
                [autoCloseDelay] = "autoCloseDelay"
                [blink] = "blink"
                [browserBoundsOffset] = "browserBoundsOffset"
                [closeOnClick] = "closeOnClick"
                [disabled] = "disabled"
                [hoverOpacity] = "hoverOpacity"
                [icon] = "icon"
                [notificationOffset] = "notificationOffset"
                [opacity] = "opacity"
                [position] = "position"
                [rtl] = "rtl"
                [showCloseButton] = "showCloseButton"
                [template] = "template"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxNotification>`
})
export class NgcNotificationComponent extends ControlComponent {
    @Input('appendContainer') appendContainer: any;
    @Input('autoOpen') autoOpen: any;
    @Input('animationOpenDelay') animationOpenDelay: any;
    @Input('animationCloseDelay') animationCloseDelay: any;
    @Input('autoClose') autoClose: any;
    @Input('autoCloseDelay') autoCloseDelay: any;
    @Input('blink') blink: any;
    @Input('browserBoundsOffset') browserBoundsOffset: any;
    @Input('closeOnClick') closeOnClick: any;
    @Input('disabled') disabled: any;
    @Input('hoverOpacity') hoverOpacity: any;
    @Input('icon') icon: any;
    @Input('notificationOffset') notificationOffset: any;
    @Input('opacity') opacity: any;
    @Input('position') position: any;
    @Input('rtl') rtl: any;
    @Input('showCloseButton') showCloseButton: any;
    @Input('template') template: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    @ViewChild('jqxNotification') jqxNotification: jqxNotificationComponent;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }
    
    open() {
        this.jqxNotification.open();
    }
}

/**
 * Notification Module
 */
@NgModule({
    imports: [CommonModule],
    exports: [NgcNotificationComponent],
    declarations: [NgcNotificationComponent, jqxNotificationComponent]
})
export class NgcNotificationModule {
}